module.exports = __webpack_public_path__ + "static/media/arrow-down-icon.8f5ef387.svg";